import {
  RECOMMENDED_ARTICLES_SUCCESS,
  RECOMMENDED_ARTICLES_REQUESTED,
  RECOMMENDED_ARTICLES_ERROR,
} from './RecommendedArticles-Actions';

/*
  retryCount: Keeps track of no. of data fetch retries by API
  retryCount Values:
   value = -1 : no retries yet, initial page load
   value = 0  : last data fetch was successful
   value > 0  : last data fetch failed, user clicked Try again
*/

const initialState = {
  isLoading: false,
  isError: false,
  error: null,
  retryCount: -1,
  data: {},
};

const Reducer = (state = initialState, action) => {
  switch (action.type) {
    case RECOMMENDED_ARTICLES_REQUESTED: {
      return { ...initialState, ...{ isLoading: true, retryCount: state.retryCount } };
    }

    case RECOMMENDED_ARTICLES_SUCCESS: {
      return { ...initialState, ...{ data: action.payload, isLoading: false, retryCount: 0 } };
    }

    case RECOMMENDED_ARTICLES_ERROR: {
      return {
        ...initialState,
        ...{
          data: {},
          isLoading: false,
          isError: true,
          retryCount: state.retryCount + 1,
        },
      };
    }
    default:
      return state;
  }
};

export default Reducer;
